import { trStatic } from "../i18n/static";

/**
 * Fachliche Art eines Stornogrunds. Spiegelt das Backend-Enum PaymentCancellationType
 * (Domain/PaymentCancellationType.cs) 1:1. Steuert den Storno-Flow: Ein Grund vom Typ
 * "Chargeback" blendet im Assistenten die Rücklastschrift-Optionen ein.
 */
export const CANCELLATION_REASON_TYPE_MANUAL = 0;
export const CANCELLATION_REASON_TYPE_CHARGEBACK = 1;
export const CANCELLATION_REASON_TYPE_REFUND = 2;

// Es gibt fachlich nur zwei Arten: Rückerstattung (Default; „manuell" zählt dazu) und Rücklastschrift.
export const CANCELLATION_REASON_TYPE_DEFAULT = CANCELLATION_REASON_TYPE_REFUND;

/** i18n-Schlüssel je Typ. Manuell (Legacy) wird wie Rückerstattung angezeigt. */
export const CANCELLATION_REASON_TYPE_LABELS: Record<number, string> = {
  [CANCELLATION_REASON_TYPE_MANUAL]: "Refund",
  [CANCELLATION_REASON_TYPE_CHARGEBACK]: "Chargeback",
  [CANCELLATION_REASON_TYPE_REFUND]: "Refund",
};

/** True, wenn der Typ eine Rücklastschrift ist (sonst Rückerstattung). */
export function isChargebackReasonType(type?: number | null): boolean {
  return Number(type) === CANCELLATION_REASON_TYPE_CHARGEBACK;
}

export function cancellationReasonTypeLabel(type?: number | null): string {
  if (type == null) return "–";
  const num = Number(type);
  if (!Number.isFinite(num)) return "–";
  if (CANCELLATION_REASON_TYPE_LABELS[num]) return trStatic(CANCELLATION_REASON_TYPE_LABELS[num]);
  return String(num);
}

/** Nur die zwei wählbaren Arten: Rückerstattung und Rücklastschrift. */
export const cancellationReasonTypeOptions = [
  { value: CANCELLATION_REASON_TYPE_REFUND, label: trStatic("Refund") },
  { value: CANCELLATION_REASON_TYPE_CHARGEBACK, label: trStatic("Chargeback") },
];
